/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CandidateRequest = {
  data: {
    email: string
    assessments?: Array<number | string>
    firstName?: string
    professional?: number | string
    company?: number | string
    username?: string
    lastName?: string
    avatar?: number | string
    externalId?: string
    assessmentResults?: Array<number | string>
    language?: CandidateRequest.language
  }
}
export namespace CandidateRequest {
  export enum language {
    EN = 'en',
    NL = 'nl',
  }
}
